/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * A React component for Maximize Icon.
 *
 * @author Ramani Govindaraju
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const Maximize = (props) => {
  const { color, ...otherProps } = props;
  return (
    <SvgIcon viewBox="0 0 16 16" {...otherProps}>
      <g fill="none" fillRule="evenodd">
        <path d="M-1-1h18v18H-1z" />
        <path
          fill={color}
          fillRule="nonzero"
          d="M0 5V2a2 2 0 0 1 2-2h3a1 1 0 1 1 0 2H2v3a1 1 0 1 1-2 0zM0
        11a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2H2a2 2 0 0 1-2-2v-3zM16 5a1
        1 0 0 1-2 0V2h-3a1 1 0 0 1 0-2h3a2 2 0 0 1 2 2v3zM16
        11v3a2 2 0 0 1-2 2h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0z"
        />
      </g>
    </SvgIcon>);
};

Maximize.propTypes = {
  color: PropTypes.string
};

Maximize.defaultProps = {
  color: '#6A7070'
};

export default Maximize;



// WEBPACK FOOTER //
// ./src/js/icons/Maximize.jsx